"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _getQrSize = require("./getQrSize");
Object.keys(_getQrSize).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _getQrSize[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _getQrSize[key];
    }
  });
});
var _mapShades = require("./mapShades");
Object.keys(_mapShades).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _mapShades[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _mapShades[key];
    }
  });
});
var _generateFileName = require("./generateFileName");
Object.keys(_generateFileName).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _generateFileName[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _generateFileName[key];
    }
  });
});
var _downloadImageFromElement = require("./downloadImageFromElement");
Object.keys(_downloadImageFromElement).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _downloadImageFromElement[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _downloadImageFromElement[key];
    }
  });
});
